import ErrorIcon from "../../../../Component/Elements/Icon/ErrorIcon/ErrorIcon"
import Text from "../../../../Component/Elements/Text/Text"
import CSS from "./static/css/ApplicationNoteMessage.module.css"

const ApplicationNoteMessage = () => {
    return (
        <div className={CSS.l_ApplicationNoteMessage_main}>
            <ErrorIcon />
            <div className={CSS.l_ApplicationNoteMessage_textContainer}>
                <Text 
                    size="size1"
                    color="gray1"
                >
                    차후 요청 사항 수정 중 편집이 시작될 수 있어요.
                </Text>
                <Text 
                    size="size1"
                    color="gray1"
                >
                    편집이 시작되면 수정 사항 반영이 어려워요.
                </Text>
            </div>
        </div>
    )
}

export default ApplicationNoteMessage;